import React from 'react';

export function useInterval(callback, delay) {
    const intervalRef = React.useRef(null);
    const callbackRef = React.useRef(callback);

    React.useEffect(() => {
        callbackRef.current = callback;
    });

    React.useEffect(() => {
        function call() {
            callbackRef.current();
        }
        if (typeof delay === 'number') {
            intervalRef.current = setInterval(call, delay);
            return () => clearInterval(intervalRef.current);
        }
    }, [delay]);
    return intervalRef;
}

export function useMousePosition() {
    const mousePosition = React.useRef({
        x: 0,
        y: 0
    });

    let mouseListener = React.useCallback(({ x, y }) => {
        mousePosition.current = { x, y };
    }, []);

    React.useEffect(() => {
        window.addEventListener('mousemove', mouseListener);
        return () => window.removeEventListener('mousemove', mouseListener);
    }, []);

    return mousePosition.current;
}
